import {
  ButtonSecondary,
  ButtonSize,
  IconLoader,
  NotificationTemplateTypes,
} from '@ui/src';
import ColumnHead from './notification-settings-column-header';
import RowWithToggle from './column-row-with-toggle';
import {
  NotificationSettingsAction,
  NotificationSettingsPage,
  NotificationSettingsSection,
} from '../../hoc/notification-settings/types';
import AllTypesRow from '../common/column-row/all-types-row';
import { ColumnWithToggleTypes } from './types';

import cn from './notification-settings.module.css';

const ColumnWithToggle = ({
  isLoading,
  onChange,
  onSelectRow,
  activePermissions,
  columnData,
  title,
  isEditable,
  selectedId,
  emptyTitle,
  error,
  popupIsOpen,
  hasAllToggleButton = true,
  onSearch,
  search,
  disabled,
  allActionsSectionButton,
}: ColumnWithToggleTypes): React.JSX.Element => {
  let content: React.JSX.Element;

  const isAllToggled =
    columnData &&
    Object.keys(columnData).every((el) =>
      activePermissions?.includes(el as NotificationTemplateTypes),
    );

  let actions = columnData;

  if (onSearch && search && columnData) {
    const nextActions:
      | NotificationSettingsSection
      | NotificationSettingsPage
      | NotificationSettingsAction = {};

    Object.keys(columnData)?.forEach((key) => {
      if (
        // @ts-ignore
        columnData[key].title?.toLowerCase()?.includes(search?.toLowerCase())
      ) {
        // @ts-ignore
        nextActions[key] = columnData[key];
      }
    });

    actions = nextActions;
  }

  if (isLoading) {
    content = (
      <div className={cn.columnLoader}>
        <IconLoader />
      </div>
    );
  } else if (error) {
    content = <div className={cn.error}>{error}</div>;
  } else {
    content = columnData ? (
      <div
        className={`${cn.columnContent} ${popupIsOpen ? cn.lessHeight : ''}`}
      >
        {hasAllToggleButton && columnData && (
          <div className={cn.columnButtonWrapper}>
            <ButtonSecondary
              text={isAllToggled ? 'Disable all' : 'Enable all'}
              size={ButtonSize.SMALL}
              className={`button-white ${cn.columnButton}`}
              disabled={!isEditable || disabled}
              onClick={() =>
                isAllToggled
                  ? onChange(
                      Object.keys(columnData) as NotificationTemplateTypes[],
                      false,
                      Object.values(columnData)[0],
                    )
                  : onChange(
                      Object.keys(columnData) as NotificationTemplateTypes[],
                      true,
                      Object.values(columnData)[0],
                    )
              }
            />
          </div>
        )}
        {allActionsSectionButton && (
          <AllTypesRow
            title="All types in section"
            onSelectRow={onSelectRow}
            isSelectedRow={selectedId === 'all'}
            isEditable={isEditable}
          />
        )}
        {/* @ts-ignore */}
        {Object.entries(actions).map(([key, value]) => (
          <RowWithToggle
            key={key}
            id={key as NotificationTemplateTypes}
            onChange={onChange}
            onSelectRow={onSelectRow}
            isSelectedRow={key === selectedId}
            isCheckedToggle={activePermissions.includes(
              key as NotificationTemplateTypes,
            )}
            item={value}
            isEditable={isEditable}
            disabled={disabled}
          />
        ))}
      </div>
    ) : (
      <div className={cn.emptyTitle}>{emptyTitle}</div>
    );
  }
  return (
    <div className={`${cn.column} ${onSelectRow ? '' : cn.permissionColumn}`}>
      <ColumnHead
        title={title}
        className={onSelectRow ? '' : cn.permissionColumn}
        onSearch={onSearch}
        value={search}
        selectedId={selectedId}
      />
      {content}
    </div>
  );
};

export default ColumnWithToggle;
